import styled from 'styled-components';

export const MOBILE_FOOTER_NAV_MAX_WIDTH_PX = 768;

export const mobileFooterNavMediaQuery = `(max-width: ${MOBILE_FOOTER_NAV_MAX_WIDTH_PX}px)`;

export const MOBILE_FOOTER_SEARCH_SECTION_HEIGHT_REM = 3.25;
export const MOBILE_FOOTER_NAV_SECTION_HEIGHT_REM = 4.45;

export const mobileBottomChromePaddingBottom = [
  `calc(${MOBILE_FOOTER_SEARCH_SECTION_HEIGHT_REM}rem`,
  `+ ${MOBILE_FOOTER_NAV_SECTION_HEIGHT_REM}rem`,
  '+ env(safe-area-inset-bottom, 0px))',
].join(' ');

export const $MobileFooterChrome = styled.div`
  display: none;

  @media ${mobileFooterNavMediaQuery} {
    display: flex;
    flex-direction: column;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 110;
    box-sizing: border-box;
    padding-bottom: env(safe-area-inset-bottom, 0px);
    background: ${({ theme }) =>
      theme.systemColors?.defaultBackground ?? theme.colors?.white ?? '#fff'};
    border-top: 1px solid
      ${({ theme }) => theme.newUI?.inputBorderColors?.default ?? '#e5e7eb'};
    box-shadow: ${({ theme }) =>
      (theme.newUI?.shadows as { level1?: string } | undefined)?.level1 ??
      '0 -2px 8px rgba(0, 0, 0, 0.06)'};
  }
`;

export const $FooterSearchSection = styled.div`
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  padding: 0.5rem 1rem 0.35rem;
`;

export const $FooterNav = styled.nav`
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  min-height: 3.75rem;
  padding: 0.35rem 0.5rem;
`;

export const $FooterNavList = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: flex-end;
  gap: 0.35rem;
  width: 100%;
  min-width: 0;
`;

export const $FooterNavItem = styled.button<{ $isActive?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  min-width: 0;
  padding: 0.35rem 0.25rem;
  border: none;
  border-radius: ${({ theme }) => theme.newUI?.borders?.mediumRadius ?? '8px'};
  background: ${({ theme, $isActive }) =>
    $isActive
      ? (theme.newUI?.variationColors?.light5 ?? '#eef2ff')
      : 'transparent'};
  color: ${({ theme, $isActive }) =>
    $isActive
      ? (theme.colors?.primary ?? '#5369eb')
      : (theme.newUI?.defaultColors?.secondaryText ?? '#64748b')};
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    color 0.15s ease;

  &:hover {
    background: ${({ theme }) => theme.newUI?.variationColors?.light5 ?? '#f5f7ff'};
    color: ${({ theme }) => theme.colors?.primary ?? '#5369eb'};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors?.primary ?? '#5369eb'};
    outline-offset: 2px;
  }
`;

export const $FooterCreateButton = styled.button<{ $isActive?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.1rem;
  min-width: 4.5rem;
  margin-top: -1.35rem;
  padding: 0.45rem 0.75rem 0.35rem;
  border: none;
  border-radius: 14px;
  background: ${({ theme, $isActive }) =>
    $isActive ? (theme.colors?.primaryDark ?? '#4458d4') : (theme.colors?.primary ?? '#5369eb')};
  color: ${({ theme }) => theme.colors?.white ?? '#fff'};
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(83, 105, 235, 0.35);
  transition:
    background-color 0.15s ease,
    transform 0.15s ease;

  &:hover {
    background: ${({ theme }) => theme.colors?.primaryDark ?? '#4458d4'};
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors?.primary ?? '#5369eb'};
    outline-offset: 2px;
  }
`;

export const $FooterCreateIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const $FooterCreateLabel = styled.span`
  font-size: 0.625rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  line-height: 1.1;
  text-align: center;
`;

export const $FooterNavIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const $FooterNavLabel = styled.span`
  font-size: ${({ theme }) => theme.fonts?.size?.megaSmall ?? '0.6875rem'};
  font-weight: ${({ theme }) => theme.fonts?.weight?.mediumFont ?? 500};
  line-height: 1.2;
  text-align: center;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
